import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 32,
    height: 32,
  },
  frame: {
    fill: '#09243f',
  },
  accent: {
    fill: '#f4b942',
  },
  letter: {
    fill: '#f7fafc',
    fontSize: 14,
    fontWeight: 700,
    fontFamily: 'Arial, sans-serif',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <rect className={classes.frame} x="2" y="2" rx="8" ry="8" width="28" height="28" />
      <rect className={classes.accent} x="7" y="9" rx="3" ry="3" width="10" height="14" />
      <text className={classes.letter} x="20" y="21">
        C
      </text>
    </svg>
  );
};
